var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderArrowIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon header-arrow-icon",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75.192c.281.25.328.666.126.97l-.068.089L2.43 7.25h16.82a.75.75 0 010 1.5H2.429l5.38 6c.25.28.252.697.019.978l-.077.08a.751.751 0 01-.98.02l-.08-.077-6.5-7.25-.015-.018a.43.43 0 01-.036-.048l.053.066a.691.691 0 01-.109-.154l-.021-.044a.707.707 0 01-.027-.069L.03 8.21a.74.74 0 010-.419l.007-.025a.843.843 0 01.027-.07l.021-.043.026-.046.012-.018.016-.024a.608.608 0 01.037-.048l.016-.018 6.5-7.25A.75.75 0 017.751.192z"
  })));
}

export default SvgHeaderArrowIconSv;